export default __webpack_public_path__ + "static/media/room1.9089a998.jpg";